import React, { useState } from "react";

import {
  ActionsMenu,
  ActionsMenuTrigger,
  MenuItem,
  ActionItem,
  BasicActionsMenuProps,
} from "ui/actions-menu";

import Icons from "assets";

interface TouchpointTableActionsMenuProps extends BasicActionsMenuProps {
  batchCanBeApproved: boolean;
  onApprove: () => void;
  onEdit: () => void;
  onDelete: () => void;
}
const BatchActionsMenu: React.FC<TouchpointTableActionsMenuProps> = ({
  item,
  batchCanBeApproved = false,
  onApprove,
  onEdit,
  onDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const iconStyles = "text-gray-600 size-5";

  const actionItems: ActionItem[] = [
    {
      icon: <Icons.Edit className={iconStyles} />,
      label: "Edit batch details",
      onClick: () => {
        onEdit();
      },
    },
    ...(batchCanBeApproved
      ? [
          {
            icon: <Icons.CheckCircle className={iconStyles} />,
            label: "Approve as client",
            onClick: () => {
              onApprove();
            },
          },
        ]
      : []),
    {
      icon: <Icons.Trash className={iconStyles} />,
      label: "Delete batch",
      onClick: () => {
        onDelete();
      },
    },
  ];

  return (
    <ActionsMenu
      itemName={item.itemName}
      open={isOpen}
      onOpen={handleMenuOpen}
      onClose={handleMenuClose}
      offsetLeft={0}
      offsetTop={12}
      trigger={<ActionsMenuTrigger size="large" />}>
      {actionItems.map((actionItem) => (
        <MenuItem
          key={actionItem.label}
          icon={actionItem.icon}
          label={actionItem.label}
          onClick={() => {
            actionItem.onClick(item.itemId);
            setIsOpen(false);
          }}
        />
      ))}
    </ActionsMenu>
  );
};

export default BatchActionsMenu;
